

import React, { useState, useEffect } from 'react'
import { EditPage } from '@equipedigitalfloripa/ed-cms/components'
import axios from '../api/client'

const Disparos = () => {
    const [isLoading, setIsLoading] = useState(false)
    const selectedData = [
        {
            name: '_id',
            type: 'hidden',
            title: 'Id'
        },
        {
            name: 'subject',
            type: 'text',
            title: "Assunto do email",
            validation: {
                required: true
            },
        },
        {
            name: 'message',
            type: 'tiny',
            title: "Mensagem do email",
            validation: {
                required: true
            },
        },
    ]

    const handleSubmit = (data) => {
        try {
            const url = process.env.REACT_APP_API_URL || 'http://localhost:3000/'
            const full_url = url + 'filiado/disparos/all'
            const options = {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }
            setIsLoading(true)
            axios.post(full_url, data, options).then((res) => {
                alert('Disparo criado com sucesso')
            }).finally(() => {
                setIsLoading(false)
            })
        } catch (error) {
            alert('Erro ao criar disparo')
        }
    }

    return (
        <>
            {isLoading ? <h1>Enviando...</h1> :
                <EditPage
                    title={`Disparos`}
                    subtitle={"Aqui você ir irá criar o email que será enviado para todos seus associados"}
                    selectedData={selectedData}
                    addFunction={handleSubmit}
                    fetchFunction={() => { }}
                    editFunction={() => { }}
                    uploadFunction={() => { }}
                    edit={false}
                    url='disparos'
                />
            }
        </>
    )
}

export default Disparos
